import "./App.css";
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useForm } from "react-hook-form";
import {
  FaGithub,
  FaLinkedin,
  FaReact,
  FaNodeJs,
  FaJava,
  FaJs,
  FaGitAlt,
  FaGitlab,
  FaJira,
  FaProjectDiagram,
  FaChartLine,
  FaComments,
  FaCode,
} from "react-icons/fa";
import {
  SiTypescript,
  SiAngular,
  SiSpring,
  SiRedux,
  SiPrime,
  SiAntdesign,
  SiPostgresql,
  SiOracle,
  SiVisualstudiocode,
  SiIntellijidea,
  SiReactivex,
  SiNextdotjs,
} from "react-icons/si";
import { projects } from "./constants/projects";
import { experience } from "./constants/experience";
import { education } from "./constants/education";
import { skills } from "./constants/skills";
import ProjectModal from "./components/ProjectModal";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Skills from "./components/Skills";
import profileImage from "./assests/images/Ali Asghar Shah.png";
import aliasgharCV from "./assests/Syed Ali Asghar Shah CV.pdf";
import ColorfulLoader from "./components/loader/ColorfulLoader";
import emailjs from "emailjs-com";

const skillsList = [
  { name: "Java", color: "#5382a1", icon: "J" },
  { name: "TypeScript", color: "#3178c6", icon: "TS" },
  { name: "JavaScript", color: "#f7df1e", icon: "JS" },
  { name: "Angular", color: "#dd0031", icon: "A" },
  { name: "React", color: "#61dafb", icon: "R" },
  { name: "Next.js", color: "#000000", icon: "N" },
  { name: "Node.js", color: "#68a063", icon: "N" },
  { name: "Spring Boot", color: "#6db33f", icon: "S" },
  { name: "GraphQL", color: "#e535ab", icon: "G" },
  { name: "RxJs", color: "#b7178c", icon: "R" },
  { name: "Redux", color: "#764abc", icon: "R" },
  { name: "PostgreSQL", color: "#336791", icon: "P" },
];
const App = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [filter, setFilter] = useState("all");
  const [visibleProjects, setVisibleProjects] = useState(9);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "home",
        "about",
        "skills",
        "projects",
        "experience",
        "education",
        "contact",
      ];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (
          element &&
          scrollPosition >= element.offsetTop &&
          scrollPosition < element.offsetTop + element.offsetHeight
        ) {
          setActiveSection(section);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: "smooth",
      });
      setActiveSection(sectionId);
      setIsMenuOpen(false);
    }
  };

  const openProjectModal = (project) => {
    setSelectedProject(project);
    document.body.style.overflow = "hidden";
  };

  const closeProjectModal = () => {
    setSelectedProject(null);
    document.body.style.overflow = "auto";
  };

  debugger;
  console.log("Selected Project:", projects);

  const filteredProjects =
    filter === "all"
      ? projects
      : projects.filter((project) => project.projectType === filter);

  const displayedProjects = filteredProjects.slice(0, visibleProjects);

  debugger;

  const loadMoreProjects = () => {
    setVisibleProjects((prev) => prev + 9);
  };

  const onSubmit = (data) => {
    const SERVICE_ID = "service_1hx5lzo";
    const TEMPLATE_ID = "template_nj05wam";
    const USER_ID = "tb6m2xkmxB1XqRGLr";
    const CONTACT_TEMPLATE_ID = "template_zil4rra";
    emailjs
      .send(SERVICE_ID, CONTACT_TEMPLATE_ID, data, USER_ID)
      .then((response) => {
        setFormSubmitted(true);
        reset(); // reset form fields
      })
      .catch((error) => {
        alert("Failed to send the message. Please try again.");
        console.error("EmailJS error:", error);
      });

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, data, "USER_ID").then(
      (result) => {},
      (error) => {
        alert("Failed to send message. Try again later.");
        console.error(error);
      }
    );

    console.log(data);
    // Handle form submission
    console.log(data);
    // Here you would typically send the data to your backend

    // reset(); // This clears the form (from react-hook-form)

    // Hide the message after 5 seconds
    setTimeout(() => setFormSubmitted(false), 10000);
  };
  const orbitVariants = {
    animate: (i) => ({
      rotate: [0, 360],
      x: [
        140,
        Math.cos(i * (Math.PI / 4)) * 140,
        Math.cos(i * (Math.PI / 2)) * 140,
        Math.cos(i * ((3 * Math.PI) / 4)) * 140,
        -140,
        Math.cos(i * ((5 * Math.PI) / 4)) * 140,
        Math.cos(i * ((3 * Math.PI) / 2)) * 140,
        Math.cos(i * ((7 * Math.PI) / 4)) * 140,
        140,
      ],
      y: [
        0,
        Math.sin(i * (Math.PI / 4)) * 140,
        Math.sin(i * (Math.PI / 2)) * 140,
        Math.sin(i * ((3 * Math.PI) / 4)) * 140,
        0,
        Math.sin(i * ((5 * Math.PI) / 4)) * 140,
        Math.sin(i * ((3 * Math.PI) / 2)) * 140,
        Math.sin(i * ((7 * Math.PI) / 4)) * 140,
        0,
      ],
      transition: {
        duration: 20,
        ease: "linear",
        repeat: Infinity,
        repeatType: "loop",
      },
    }),
  };

  const pulseVariants = {
    animate: {
      scale: [1, 1.1, 1],
      opacity: [0.8, 1, 0.8],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
  };

  return (
    <div className="portfolio-container">
      {loading && <ColorfulLoader />};{/* Animated Background Elements */}
      <div className="bg-shapes">
        {[...Array(10)].map((_, i) => (
          <motion.div
            key={i}
            className="shape"
            initial={{ opacity: 0, scale: 0 }}
            animate={{
              opacity: [0.1, 0.3, 0.1],
              scale: [1, 1.2, 1],
              x: Math.random() * 100 - 50,
              y: Math.random() * 100 - 50,
            }}
            transition={{
              duration: 10 + Math.random() * 20,
              repeat: Infinity,
              repeatType: "reverse",
            }}
          />
        ))}
      </div>
      {/* Enhanced Navigation */}
      <nav className="navbar">
        <motion.div
          className="logo"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <span className="logo-highlight">A</span>shah
        </motion.div>

        <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
          {[
            "home",
            "about",
            "skills",
            "projects",
            "experience",
            "education",
            "contact",
          ].map((item) => (
            <button
              key={item}
              className={`nav-link ${activeSection === item ? "active" : ""}`}
              onClick={() => scrollToSection(item)}
            >
              {item.charAt(0).toUpperCase() + item.slice(1)}
              {activeSection === item && (
                <motion.div
                  className="nav-underline"
                  layoutId="nav-underline"
                  initial={false}
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}
            </button>
          ))}
        </div>

        <button
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <div className={`hamburger ${isMenuOpen ? "open" : ""}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </nav>
      {/* Hero Section with Improved Layout */}
      <section id="home" className="hero-section">
        <div className="container">
          <div className="hero-content">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="hero-text"
            >
              <h4 className="greeting">Hello, I'm</h4>
              <h1 className="name">Syed Ali Asghar Shah</h1>
              <h2 className="title">
                Digital Transformation Expert |Full Stack Engineer
              </h2>
              <p className="summary">
                A dynamic professional with 9+ years of experience in analyzing,
                designing and developing full-stack solutions in agile
                environments.
              </p>

              <div className="hero-buttons">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="primary-btn"
                  onClick={() => scrollToSection("projects")}
                >
                  View My Work
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="secondary-btn"
                  onClick={() => scrollToSection("contact")}
                >
                  Contact Me
                </motion.button>
              </div>
            </motion.div>

            <div className="hero-animation">
              <div className="fullstack-text">Full Stack</div>
              <div className="orbit-center">
                <div className="orbit-item orbit-1">
                  <FaJava />
                  <span>Java</span>
                </div>
                <div className="orbit-item orbit-2">
                  <SiTypescript />
                  <span>TypeScript</span>
                </div>
                <div className="orbit-item orbit-3">
                  <FaJs />
                  <span>JavaScript</span>
                </div>
                <div className="orbit-item orbit-4">
                  <SiAngular />
                  <span>Angular</span>
                </div>
                <div className="orbit-item orbit-5">
                  <FaReact />
                  <span>React</span>
                </div>
                <div className="orbit-item orbit-6">
                  <SiSpring />
                  <span>Spring</span>
                </div>
                <div className="orbit-item orbit-7">
                  <FaNodeJs />
                  <span>Node.js</span>
                </div>
                <div className="orbit-item orbit-8">
                  <SiPostgresql />
                  <span>PostgreSQL</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <motion.div
          className="scroll-indicator"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          onClick={() => scrollToSection("about")}
        >
          <span>Scroll Down</span>
          <div className="arrow"></div>
        </motion.div>
      </section>
      {/* About Section */}
      <section id="about" className="about-section">
        <div className="container">
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            About <span>Me</span>
          </motion.h2>

          <div className="about-content">
            <motion.div
              className="about-image"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="about-profile">
                <img src={profileImage} alt="Ali_Profile_Image" />
              </div>
            </motion.div>

            <motion.div
              className="about-text"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h3>Digital Transformation Expert | Full-Stack Engineer</h3>

              <p>
                I’m a digital transformation expert with 9+ years of hands-on
                experience helping startups, corporates, and governments turn
                ideas into scalable software solutions. With a background in
                Computer Science and an MBA in Finance & Business Analytics, I
                bring a rare blend of technical, business, and strategic insight
                to every project. I’ve worked across diverse industries—from
                healthcare, fintech, and property management to e-government and
                AI-driven platforms. Whether leading full-stack development,
                optimizing operations, or shaping product strategies, I focus on
                delivering solutions that solve real business problems. My goal
                is always to unlock value, drive efficiency, and empower
                organizations to grow through technology.
              </p>

              <div className="about-details">
                <div className="detail-item">
                  <span className="detail-label">Name:</span>
                  <span className="detail-value">Syed Ali Asghar Shah</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Email:</span>
                  <span className="detail-value">alishah3630@gmail.com</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">From:</span>
                  <span className="detail-value">Islamabad, Pakistan</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Experience:</span>
                  <span className="detail-value">9+ Years</span>
                </div>
              </div>

              <div className="about-actions">
                <motion.a
                  // href="/assets/Ali_Asghar_Resume.pdf"
                  href={aliasgharCV}
                  target="_blank"
                  rel="noopener noreferrer"
                  download="Ali Asghar CV.pdf"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="primary-btn"
                >
                  Download CV
                </motion.a>
                {/* Syed Ali Asghar Shah CV */}
                <motion.a
                  href="#"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="secondary-btn"
                >
                  View Education
                </motion.a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Skills Section */}
      <Skills skills={skills} />
      {/* Projects Section */}
      <section id="projects" className="projects-section">
        <div className="container">
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            My <span>Projects</span>
          </motion.h2>

          <div className="projects-filter">
            {[
              "all",
              "fullStack",
              "frontend",
              "backend",
              "government",
              "healthcare",
            ].map((filterItem) => (
              <button
                key={filterItem}
                className={`filter-btn ${
                  filter === filterItem ? "active" : ""
                }`}
                onClick={() => {
                  setFilter(filterItem);
                  setVisibleProjects(9);
                }}
              >
                {filterItem.charAt(0).toUpperCase() + filterItem.slice(1)}
              </button>
            ))}
          </div>

          <div className="projects-grid">
            {displayedProjects.map((project, index) => (
              <motion.div
                key={project.id}
                className="project-card"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div
                  className="project-image"
                  style={{
                    backgroundImage: `url(https://via.placeholder.com/600x400?text=${project.title.replace(
                      /\s+/g,
                      "+"
                    )})`,
                  }}
                >
                  <div className="project-overlay">
                    <h3>{project.title}</h3>
                    <p>{project.subtitle}</p>
                  </div>
                </div>
                <div className="project-details">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="project-tech">
                    {project.technologies.map((tech, i) => (
                      <span key={i}>{tech}</span>
                    ))}
                  </div>
                  {project.hasDetails && (
                    <div className="project-actions">
                      <button
                        className="view-btn"
                        onClick={() => openProjectModal(project)}
                      >
                        View Details
                      </button>
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </div>

          {filteredProjects.length > visibleProjects && (
            <motion.button
              className="load-more"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={loadMoreProjects}
            >
              Load More Projects
            </motion.button>
          )}
        </div>
      </section>
      {/* Experience Section */}
      <Experience experience={experience} />
      {/* Education Section */}
      <Education education={education} />
      {/* Contact Section with Form Validation */}
      <section id="contact" className="contact-section">
        <div className="container">
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            Get In <span>Touch</span>
          </motion.h2>

          <div className="contact-container">
            <motion.div
              className="contact-info"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h3>Contact Information</h3>
              <p>
                Feel free to reach out to me for any questions or opportunities.
                I'm always open to discussing new projects, creative ideas or
                opportunities to be part of your vision.
              </p>

              <div className="info-items">
                <div className="info-item">
                  <div className="info-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    </svg>
                  </div>
                  <div className="info-content">
                    <h4>Location</h4>
                    <p>Islamabad, Pakistan</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                    </svg>
                  </div>
                  <div className="info-content">
                    <h4>Email</h4>
                    <p>alishah3630@gmail.com</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                    </svg>
                  </div>
                  <div className="info-content">
                    <h4>Phone</h4>
                    <p>+92 341 600 3630</p>
                  </div>
                </div>
              </div>

              <div className="social-links">
                <a
                  href="https://www.linkedin.com/in/syed-ali-asghar-shah/"
                  className="social-icon"
                >
                  <FaLinkedin />
                </a>
                <a href="https://github.com/asghar3630" className="social-icon">
                  <FaGithub />
                </a>
              </div>
            </motion.div>

            <motion.form
              className="contact-form"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              onSubmit={handleSubmit(onSubmit)}
            >
              {formSubmitted && (
                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  className="success-message"
                >
                  <div className="success-icon">✓</div>
                  Your message has been sent successfully!
                </motion.div>
              )}
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Your Name"
                  {...register("name", { required: "Name is required" })}
                  className={errors.name ? "error" : ""}
                />
                {errors.name && (
                  <span className="error-message">{errors.name.message}</span>
                )}
              </div>
              <div className="form-group">
                <input
                  type="email"
                  placeholder="Your Email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email address",
                    },
                  })}
                  className={errors.email ? "error" : ""}
                />
                {errors.email && (
                  <span className="error-message">{errors.email.message}</span>
                )}
              </div>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Subject"
                  {...register("subject", {
                    required: "Subject is required",
                    minLength: {
                      value: 5,
                      message: "Subject must be at least 5 characters",
                    },
                    maxLength: {
                      value: 100,
                      message: "Subject must be less than 100 characters",
                    },
                  })}
                  className={errors.subject ? "error" : ""}
                />
                {errors.subject && (
                  <span className="error-message">
                    {errors.subject.message}
                  </span>
                )}
              </div>
              <div className="form-group">
                <textarea
                  placeholder="Your Message"
                  rows="5"
                  {...register("message", {
                    required: "Message is required",
                    minLength: {
                      value: 10,
                      message: "Message must be at least 10 characters",
                    },
                  })}
                  className={errors.message ? "error" : ""}
                ></textarea>
                {errors.message && (
                  <span className="error-message">
                    {errors.message.message}
                  </span>
                )}
              </div>
              <motion.button
                type="submit"
                className="primary-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Send Message
              </motion.button>
            </motion.form>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="footer">
        <motion.div
          className="footer-content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="footer-logo">
            <span className="logo-highlight">A</span>shah
          </div>
          <p className="footer-text">
            A passionate Full Stack Engineer dedicated to building innovative
            digital solutions.
          </p>
          <div className="footer-links">
            <a href="#home">Home</a>
            <a href="#about">About</a>
            <a href="#skills">Skills</a>
            <a href="#projects">Projects</a>
            <a href="#contact">Contact</a>
          </div>
          <div className="footer-social">
            <a href="https://www.linkedin.com/in/syed-ali-asghar-shah/">
              <FaLinkedin />
            </a>
            <a href="https://github.com/asghar3630">
              <FaGithub />
            </a>
          </div>
          <div className="footer-copyright">
            &copy; {new Date().getFullYear()} Syed Ali Asghar Shah. All rights
            reserved.
          </div>
        </motion.div>
      </footer>
      {/* Project Modal */}
      <AnimatePresence>
        {selectedProject && (
          <ProjectModal project={selectedProject} onClose={closeProjectModal} />
        )}
      </AnimatePresence>
    </div>
  );
};

export default App;
